export const categories = [
  { id: 1, slug: 'movies', name: '电影', icon: 'ri-movie-line', count: 2856 },
  { id: 2, slug: 'tv-series', name: '电视剧', icon: 'ri-tv-line', count: 3421 },
  { id: 3, slug: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line', count: 1523 },
  { id: 4, slug: 'anime', name: '动漫', icon: 'ri-rocket-line', count: 2108 },
  { id: 5, slug: 'documentary', name: '纪录片', icon: 'ri-earth-line', count: 896 },
  { id: 6, slug: 'kids', name: '少儿', icon: 'ri-heart-line', count: 632 },
  { id: 7, slug: 'short-video', name: '短视频', icon: 'ri-vidicon-line', count: 4567 },
  { id: 8, slug: 'exclusive', name: '独家剧集', icon: 'ri-vip-crown-line', count: 347 },
];